<template>
  <div>
    <div class="device-status-bar-cla'" v-if="status === 0">
      <div class="device-online-cla"></div>
      <span>{{ $t('device.online') }}</span>
    </div>
    <div class="device-status-bar-cla'" v-else>
      <div class="device-offline-cla"></div>
      <span> {{ $t('device.offLine') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {
    showTitle: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    status: {
      type: Number,
      default: 0
    }
  },
  mounted() {},
  methods: {}
}
</script>

<style scoped lang="less">
.deviceStatus_cla {
  .zaixian {
    color: #78bc27;
    font-size: 17px;
  }
  .lixian {
    color: #ea1422;
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/comComponent/deviceStatus.vue